import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { SiaI18nDirective, SiaSizeDetectorService } from '@sia/shared';
import {
  DxNumberBoxModule,
  DxScrollViewComponent,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-advanced',
  templateUrl: './sia-grid-config-advanced.component.html',
  styleUrls: ['./sia-grid-config-advanced.component.scss'],
  standalone: true,
  imports: [
    DxScrollViewModule,
    SiaI18nDirective,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxSwitchModule,
  ],
})
export class SiaGridConfigAdvancedComponent
  extends SiaGridConfigTab
  implements OnInit, OnDestroy
{
  @ViewChild(DxScrollViewComponent, { static: false })
  scroll: DxScrollViewComponent | undefined | null;

  gridConfScrollingTypes: string[] = ['infinite', 'virtual', 'page'];
  gridConfSelectionTypes: string[] = ['single', 'multiple'];
  private sizeDetector = inject(SiaSizeDetectorService);

  @HostListener('window:unload')
  ngOnDestroy() {
    if (this.scroll && this.scroll.instance) {
      this.scroll.instance.dispose();
      this.scroll = null;
    }
    this.gridConfScrollingTypes = [];
    this.gridConfSelectionTypes = [];
    super.ngOnDestroy();
  }
}
